import React, { FC } from 'react'

const SendIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_2250_321)">
            <path
                d="M0 13.5V0.5L15.423 7L0 13.5ZM1 12L12.85 7L1 2V5.885L5.846 7L1 8.115V12Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_2250_321">
                <rect width="16" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default SendIcon
